import React from "react";

import useNavigation from "@/utils/useNavigate";
import KeepAlive from "react-activation";
import { useSearchParams } from "react-router-dom";
import Index from "./index";

interface Props {
  pagePath?: any;
}
/**
 * 素材图文情页
 * @returns 推广详情
 */
const PromoteDetailContainer: React.FC<Props> = () => {
  const {navigate2H5} = useNavigation();
  const [search] = useSearchParams();
  const materialNo = search.get("materialNo");
  // const shopId = search.get("shopId");
  // const fromPage = search.get("fromPage");
  // const objectIds = search.get("objectIds");
  // const baseProductIds = search.get("baseProductIds");
  // return;
  const cacheKey = materialNo ? `zhongcaoxiangqingye-${materialNo}` : "zhongcaoxiangqingye";
  return (
    <KeepAlive cacheKey={cacheKey} saveScrollPosition={true}>
      <Index />
    </KeepAlive>
  );
};

export default PromoteDetailContainer;
